import { ContentfulDocumentSlug } from 'api/contentful/getDocument'
import { Block } from 'components/Block'
import { ContentfulDocument } from 'components/contentfulDocument/ContentfulDocument'
import { Footer } from 'components/footer/Footer'
import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Layout } from 'components/layout/Layout'
import { PageTitle } from 'components/PageTitle'
import { pxToRem } from 'utils/styled'

export const ContentfulDocumentPage = ({
  slug,
  metaTitle,
}: {
  slug: ContentfulDocumentSlug
  metaTitle: string
}) => (
  <Layout
    header={<TopNavigationLandingPage variant="general-info" />}
    footer={<Footer variant="estate-planning" />}
  >
    <PageTitle title={metaTitle} />
    <Block>
      <section css={{ maxWidth: `${pxToRem(800)}rem`, margin: '0 auto' }}>
        <ContentfulDocument slug={slug} />
      </section>
    </Block>
  </Layout>
)
